// extracted by mini-css-extract-plugin
export default {"error":"_4biGq","btn":"oNYeT"};